/*
 * GTS infinite scroll - korvaa Scrollify-appin.
 *
 * Miksi oma: appi (infi_script.js) ei paivita seuraavan sivun osoitinta, joten se
 * pysahtyy sivun 2 jalkeen. Ks. Obsidian: Storefront / Teemu testii -teema.
 *
 * Periaatteet:
 * - Tilaton. Nykyinen sivu ja sivumaara luetaan aina DOM:sta (.pagination--of),
 *   ei muistista. Siksi teeman oma suodatinlataus (theme.js renderGridHtml) ei
 *   voi jattaa tata epatahtiin.
 * - Teeman oma numeroitu sivutus jaa NAKYVIIN. Jos JS kaatuu tai estetaan,
 *   asiakas paasee silti kaikille sivuille ja hakukone nakee oikeat linkit.
 * - Liitos tehdaan samoihin kohtiin kuin teeman oma AJAX: [data-body-grid] ja
 *   [data-body-pagination], ja lopuksi ajetaan samat tapahtumat.
 */
(function () {
  'use strict';

  var cfg = window.GTS_INFINITE || {};
  // Kuinka lahelta latauskohtaa lataus laukeaa, pikseleina viewportin alareunasta.
  var THRESHOLD = typeof cfg.threshold === 'number' ? cfg.threshold : 800;
  // Tauko peräkkäisten latausten valilla kun asiakas seisoo sivun pohjalla.
  var CHAIN_DELAY = typeof cfg.chainDelay === 'number' ? cfg.chainDelay : 300;

  function trigger(name) {
    if (typeof window.trigger === 'function') window.trigger(name);
  }

  function init() {
    var wrapper = document.querySelector('[data-body-wrapper]');
    if (!wrapper) return;

    var grid = wrapper.querySelector('[data-body-grid]');
    var pagination = wrapper.querySelector('[data-body-pagination]');
    if (!grid || !pagination || !pagination.parentNode) return;
    if (wrapper.querySelector('[data-gts-more]')) return; // idempotentti

    var loading = false;
    // Epaonnistumista EI lukita pysyvasti. Kauppa antaa herkasti HTTP 429
    // ("Verifying your connection...") -haasteita, ja aiempi versio kuoli
    // ensimmaiseen niista lopullisesti: automaattilataus jai pois pain koko
    // sivun ajaksi ja palasi vasta napin painalluksesta. Nyt yritetaan uudelleen
    // kasvavalla tauolla, ja varapolku (nuolet + nappi) nousee esiin heti.
    var failCount = 0;
    var cooldownUntil = 0;
    var retryTimer = null;
    var MAX_FAILS = 5;
    var BACKOFF = [1500, 4000, 10000, 20000, 30000];
    // Automaattilataus on kaytossa vain jos selain tukee tarvittavat rajapinnat.
    var autoEnabled = typeof window.requestAnimationFrame === 'function';
    var scrollQueued = false;
    var chainTimer = null;

    var bar = document.createElement('div');
    bar.className = 'gts-more--root';
    bar.setAttribute('data-gts-more', '');
    bar.setAttribute('data-container', 'block');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gts-more--button';
    if (cfg.label) {
      button.setAttribute('data-text', cfg.label);
      var span = document.createElement('span');
      span.textContent = cfg.label;
      button.appendChild(span);
    }
    button.hidden = true; // nakyy vain jos automaattilataus ei ole kaytossa tai se epaonnistui
    bar.appendChild(button);

    pagination.parentNode.insertBefore(bar, pagination);

    // Nykyinen sivu ja sivumaara teeman sivutuslaskurista ("2 / 13").
    function readState() {
      var counter = pagination.querySelector('.pagination--of');
      if (!counter) return null;
      // GTS-LOCALE-PAGINATION-FIX: erotin tulee kielitiedoston pagination.of
      // -arvosta ja on eri kielilla eri: fi = kauttaviiva, en = sana of.
      // Kauttaviivaan sidottu regex jatti EN-puolen jumiin sivulle 1.
      var match = counter.textContent.match(/(\d+)\D+(\d+)/);
      if (!match) return null;
      var current = parseInt(match[1], 10);
      var total = parseInt(match[2], 10);
      if (!current || !total) return null;
      return { current: current, total: total };
    }

    function nextUrl(page) {
      var url = new URL(window.location.href);
      url.hash = ''; // teeman sivutuslinkeissa on #collection_root, se ei kuulu hakuun
      url.searchParams.set('page', String(page));
      return url.toString();
    }

    function hasMore() {
      var state = readState();
      return !!state && state.current < state.total;
    }

    // Liitettyjen korttien paljastus.
    //
    // Teeman CSS piilottaa jokaisen [data-transition-item]:n
    // (visibility:hidden, opacity:0) kunnes silla on data-transition-active
    // ="true". Sen asettaa teeman Transition-luokka per-kortti-observerilla.
    //
    // EI kayteta teeman omaa 'theme:transition:reload:<id>' -tapahtumaa.
    // Mitattu selaimesta: se ajaa destroy() -> resetItems(), joka asettaa
    // KAIKKI kortit tilaan data-transition-active="false", ja luottaa siihen
    // etta IntersectionObserver aktivoi ne uudelleen. Jo nakyvyysalueella
    // oleville se ei laukea, joten koko ruudukko jai piiloon: aktiivisia
    // kortteja 16 -> 0, eika tila palautunut 2,5 s odotuksella, vierityksella
    // eika resizella. Siksi asetetaan attribuutti suoraan, mika on
    // deterministista eika voi piilottaa mitaan.
    function revealAppended(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!node || node.nodeType !== 1) continue;
        var items = [];
        if (node.hasAttribute('data-transition-item')) items.push(node);
        var nested = node.querySelectorAll('[data-transition-item]');
        for (var j = 0; j < nested.length; j++) items.push(nested[j]);
        for (var k = 0; k < items.length; k++) reveal(items[k]);
      }
    }

    function reveal(item) {
      item.setAttribute('data-transition-active', 'true');
      // Sama lopputila kuin teeman omilla korteilla (setItemState).
      var done = function () {
        item.setAttribute('data-transition-finished', 'true');
      };
      item.addEventListener('transitionend', done, { once: true });
      window.setTimeout(done, 1000);
    }

    function sync() {
      // GTS-LOCALE-PAGINATION-FIX: tila luetaan kerran ja sita katsotaan myos
      // piilotuspaatoksessa alla. Aiemmin ehto oli pelkka failCount === 0,
      // jolloin 'tilaa ei voitu lukea' laskettiin ehjaksi ja teeman nuolet
      // piilotettiin vaikka mitaan ei ollut ladattu.
      var state = readState();
      var more = !!state && state.current < state.total;
      bar.hidden = !more;
      // Nappi nakyviin vain kun automaattilatausta ei ole tai se on kaatunut.
      button.hidden = !more || (autoEnabled && failCount === 0);

      // Nuolirivi piiloon kun lataus toimii, takaisin nakyviin jos se kaatuu.
      // Elementti jaa AINA DOM:iin: hakukoneet nakevat sivulinkit ja ilman
      // JS:aa nappi ja nuolet ovat asiakkaan ainoa polku eteenpain.
      if (failCount > 0 || !state) {
        pagination.removeAttribute('data-gts-hidden');
      } else {
        pagination.setAttribute('data-gts-hidden', '');
      }
    }

    function load() {
      if (loading) return Promise.resolve();
      var state = readState();
      if (!state || state.current >= state.total) {
        sync();
        return Promise.resolve();
      }

      loading = true;
      bar.setAttribute('aria-busy', 'true');
      button.disabled = true;

      var retryAfterMs = 0;

      return fetch(nextUrl(state.current + 1), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            // Shopifyn bottisuoja vastaa 429:lla ja HTML-haastesivulla. Jos se
            // kertoo Retry-Afterin, kuunnellaan sita oman taukoportaan sijaan.
            var retryAfter = parseInt(response.headers.get('Retry-After'), 10);
            if (retryAfter > 0) retryAfterMs = Math.min(retryAfter * 1000, 60000);
            throw new Error('HTTP ' + response.status);
          }
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-body-grid]');
          if (!newGrid || !newGrid.firstChild) throw new Error('grid puuttuu vastauksesta');

          var fragment = document.createDocumentFragment();
          var appended = [];
          while (newGrid.firstChild) {
            var child = newGrid.firstChild;
            if (child.nodeType === 1) appended.push(child);
            fragment.appendChild(child);
          }
          grid.appendChild(fragment); // custom elementit (quick-add) heraavat itse

          var newPagination = doc.querySelector('[data-body-pagination]');
          if (newPagination) pagination.innerHTML = newPagination.innerHTML;

          failCount = 0;
          cooldownUntil = 0;
          window.requestAnimationFrame(function () {
            revealAppended(appended);
          });
          trigger('theme:navigation:reloaded');
        })
        .catch(function () {
          // Ei kaadeta sivua. Nuolet ja nappi nousevat heti varapoluiksi, ja
          // uudelleenyritys ajastetaan. Vain MAX_FAILS peraakkaista virhetta
          // lopettaa automaattilatauksen kokonaan.
          failCount = failCount + 1;
          var wait = retryAfterMs || BACKOFF[Math.min(failCount - 1, BACKOFF.length - 1)];
          cooldownUntil = Date.now() + wait;
          if (failCount < MAX_FAILS) scheduleRetry(wait);
        })
        .then(function () {
          loading = false;
          bar.removeAttribute('aria-busy');
          button.disabled = false;
          sync();
        });
    }

    function scheduleRetry(wait) {
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(function () {
        retryTimer = null;
        maybeLoad();
      }, wait + 50);
    }

    button.addEventListener('click', function () {
      // Kasin painettu yritys nollaa tauon, mutta ei virhelaskuria: jos se
      // onnistuu, laskuri nollautuu joka tapauksessa onnistumispolussa.
      cooldownUntil = 0;
      load().then(maybeLoad);
    });

    // Etaisyysmittaus, EI IntersectionObserveria.
    //
    // IO laukeaa vain risteamisen muuttuessa. Latauskohdan alapuolella on
    // sivutus ja footer, joten asiakas voi vierittaa sen ohi: silloin elementti
    // on viewportin YLAPUOLELLA, isIntersecting on false eika uutta laukaisua
    // tule ennen kuin vieritetaan takaisin ylos. Mitattu: lataus pysahtyi
    // sivulle 12 / 13 kun barTop oli -521. Siksi tassa katsotaan etaisyytta.
    function shouldLoad() {
      if (loading || !autoEnabled) return false;
      if (failCount >= MAX_FAILS) return false;
      if (Date.now() < cooldownUntil) return false;
      if (!hasMore()) return false;
      var rect = bar.getBoundingClientRect();
      return rect.top < window.innerHeight + THRESHOLD;
    }

    function maybeLoad() {
      if (!shouldLoad()) return;
      load().then(function () {
        // Jos asiakas seisoo pohjalla, jatketaan ketjussa pienella tauolla.
        if (chainTimer) window.clearTimeout(chainTimer);
        chainTimer = window.setTimeout(maybeLoad, CHAIN_DELAY);
      });
    }

    function onScroll() {
      if (scrollQueued) return;
      scrollQueued = true;
      window.requestAnimationFrame(function () {
        scrollQueued = false;
        maybeLoad();
      });
    }

    if (autoEnabled) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    // Teeman oma suodatin/lajittelulataus korvaa gridin ja sivutuksen sisallon.
    // Tila luetaan aina DOM:sta, joten riittaa nollata virhetila ja paivittaa nappi.
    if (typeof window.on === 'function') {
      window.on('theme:navigation:reloaded', function () {
        if (loading) return;
        // Suodatin- tai lajittelulataus on korvannut gridin ja sivutuksen,
        // eli tilanne on uusi: virhehistoria nollataan.
        failCount = 0;
        cooldownUntil = 0;
        sync();
        maybeLoad();
      });
    }

    sync();
    maybeLoad(); // sivu voi latautua jo valmiiksi vieritettyna
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
